import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const LinkTextStyled = styled(Link)`
  display: inline-block;
  color: ${p => p.theme.colors.primary20b};
  text-decoration: none;
  line-height: 1;
  margin: 0;
  cursor: pointer;

  &:focus,
  &:active,
  &:hover {
    color: ${p => p.theme.colors.primary20b};
    text-decoration: underline;
  }
`;

export const TextStyled = styled.span`
  display: inline-block;
  color: ${p => p.theme.colors.primary20b};
  text-decoration: none;
  line-height: 1;
  margin: 0;
  cursor: pointer;

  &:focus,
  &:active,
  &:hover {
    color: ${p => p.theme.colors.primary20b};
    text-decoration: underline;
  }

  & a {
    color: ${p => p.theme.colors.primary20b};
  }

  &:focus a,
  &:active a,
  &:hover a {
    color: ${p => p.theme.colors.primary20b};
    text-decoration: underline;
  }
`;
